export default (function reverseAnsiText(text) {
  return text;
});